/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Plan_Change_Credit_NoteInputs */

const en_plan_change_credit_note = /** @type {(inputs: Plan_Change_Credit_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You'll be credited ${i?.amount} toward future invoices. Nothing is refunded to your card.`)
};

const es_plan_change_credit_note = /** @type {(inputs: Plan_Change_Credit_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se te acreditarán ${i?.amount} para futuras facturas. No se reembolsa nada a tu tarjeta.`)
};

/**
* | output |
* | --- |
* | "You'll be credited {amount} toward future invoices. Nothing is refunded to your card." |
*
* @param {Plan_Change_Credit_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_credit_note = /** @type {((inputs: Plan_Change_Credit_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Credit_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_credit_note(inputs)
	return en_plan_change_credit_note(inputs)
});